import { render, staticRenderFns } from "./MaintenanceDetail.vue?vue&type=template&id=023f6009&scoped=true"
import script from "./MaintenanceDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceDetail.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceDetail.vue?vue&type=style&index=0&id=023f6009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f6009",
  null
  
)

export default component.exports